import { styled, GetProps, Stack } from 'tamagui'

export const Card = styled(Stack, {
  name: 'Card',
  
  // Base styles - Brutalist
  backgroundColor: '$backgroundMuted',
  borderRadius: 0,
  flexDirection: 'column',
  borderWidth: 2,
  borderColor: '$borderColor',
  padding: '$4',
  
  variants: {
    interactive: {
      hover: {
        cursor: 'pointer',
        hoverStyle: {
          borderColor: '$accent',
        },
      },
      press: {
        cursor: 'pointer',
        pressStyle: {
          opacity: 0.8,
          scale: 0.98,
        },
        hoverStyle: {
          borderColor: '$accent',
        },
      },
      none: {},
    },
    state: {
      selected: {
        borderColor: '$accent',
        backgroundColor: '$background',
      },
      default: {},
    },
    size: {
      none: { padding: 0 },
      sm: { padding: '$2' },
      md: { padding: '$4' },
      lg: { padding: '$6' },
    },
  } as const,
  
  defaultVariants: {
    size: 'md',
  },
})

export type CardProps = GetProps<typeof Card>
